import React, { useState, useEffect } from "react";
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import { useSelector } from "react-redux";
import { FindSecondChild } from "../../../../utils/FindMenuOption";
import States from "../../../../utils/Constants";
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";


const Statement = () => {
  let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Statement')?.IsAdd

  let Statement_model = {
    "StatementCycleDays": "",
    "MinimumAccountBalance": "",
    "0to30DayDunningMessage": "",
    "31to60DayDunningMessage": "",
    "61to90DayDunningMessage": "",
    "Over90DayDunningMessage": "",
    "NumberOfDaysAfterFirstStatementSend": "",
    "NumberOfStatementSent": "",
    "DisplayAppointmentFicility": false,
    "DisplayCPTDescription": false,
    "DisplayPayments": false,
    "DisplayCPTCode": false,
    "DisplayClaimAdjustment": false,
    'Name': '',
    'Address': '',
    'City': '',
    'State': '',
    'ZIPCode': '',
    'Email': '',
    "PhoneNo": '',
    "IncludeLogo": false,
    'IncludeFooter': false


  }
  const API_URL = enumUtil.controller.General
  const [providerSaveUpdateModal, setProviderSaveUpdateModal] = useState({})
  const [mainProvidereModal, setmainProvidereModal] = useState(Statement_model);
  const [is, setIs] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [StatementID, setStatementID] = useState()

  useEffect(() => {


    setIsLoading(true)
    ServerRequestProtected(API_URL + "/FindByID", 'post', {
      "TableName": enumUtil.enumAPITableName.StatementSetting
    }).then((response) => {
      setIsLoading(false)
      setIs(true)
      setmainProvidereModal(response)
      setStatementID(response.StatementSettingID)
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      if (error.response.data === 'No Data Found!') {
        setStatementID('0')
      }
      setIsLoading(false)
    })

  }, [])
  const handleProviderChange = (e) => {
    let { name, value } = e.target;
    let modal = { ...mainProvidereModal };
    let saveModal = { ...providerSaveUpdateModal }
    if (name === "DisplayAppointmentFicility" || name === 'DisplayCPTDescription' || name === 'DisplayPayments' || name === 'DisplayCPTCode' || name === 'DisplayClaimAdjustment' || name === 'IncludeFooter' || name === 'IncludeLogo') {
      modal[name] = !modal[name]
    } else {
      modal[name] = value
    }
    setmainProvidereModal(modal)
    for (var property in Statement_model) {
      if (name === property) {
        if (name === "DisplayAppointmentFicility" || name === 'DisplayCPTDescription' || name === 'DisplayPayments' || name === 'DisplayCPTCode' || name === 'DisplayClaimAdjustment' || name === 'IncludeFooter' || name === 'IncludeLogo') {
          saveModal[name] = modal[name] + ""
        } else {
          saveModal[name] = value
        }
      }
    }
    setProviderSaveUpdateModal(saveModal)
  }
  const handleSaveProvider = async () => {

    // await ProviderValidation()
    // let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    // if (validation) {
    //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
    //     return
    // } else
    {

      setProviderSaveUpdateModal(providerSaveUpdateModal)
      let saveModal = {
        TableName: enumUtil.enumAPITableName.StatementSetting,
        ID: StatementID,
        Data: { ...providerSaveUpdateModal },
        // value: null
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            setStatementID(response.id)
          }
        }).catch((error) => {
          setIsLoading(false)
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
  }

  const handleLocationChangeDD = (e) => {
    setIs(false)
    let { name, value } = e.target;
    let modal = { ...mainProvidereModal };
    modal[name] = value
    setmainProvidereModal(modal)
  }

  const handleSelectedData = (selectedData, name, type) => {

    let modal = { ...mainProvidereModal };
    if (type === 'client' && !isNull(selectedData)) {
      console.log(selectedData, name, type);
      if (name === 'State') {
        modal[name] = selectedData.display
        providerSaveUpdateModal[name] = selectedData.value;
      }


    } else if (type === 'server' && !isNull(selectedData)) {
      // if (name === 'POSCode') {
      //     LocationSaveUpdateModal[name] = selectedData.ID
      //     setPOS(selectedData.ID)

    } else {
      modal[name] = ''
      providerSaveUpdateModal[name] = ''
    }
    setmainProvidereModal(modal)

    return selectedData
  }
  const AddNewStatementModalBody = () => {
    return (
      <div className="hk-statement">
        <div className=" d-flex flex-column gap-2">
          <div className="hk-statement__body d-flex flex-column">

            <div className="hk-statement__body__head d-flex align-items-center justify-content-between">
              <div className="">
                <div className="d-flex align-items-center gap-6 mb-2px">
                  <i class="icon-E-Statements fs-13 clr-dark"></i>
                  <p className='heading fs-13'>E-Statements</p>
                </div>
                <p className="text fs-11 ar-light-color">Allow patients to receive their statements electronically by email with secure payment option.</p>
              </div>

              <div class="pe-0 m-0 insurance_radio_btn ar-toggle">
                <div class="form-check form-switch radio_button mh-unset m-0 d-flex">
                  <input
                    class="form-check-input float-none m-0"
                    type="checkbox"
                    id="Enable2FA"
                    name="Enable2FA"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="hk-statement__body d-flex flex-column">
            <div className="hk-statement__body__head d-flex align-items-center gap-6">
              <i class="icon-Statement-Generation fs-13 clr-dark"></i>
              <p className='heading fs-13 lh-1'>Statement Generation</p>
            </div>
            <div className="hk-statement__body__content d-flex align-items-center gap-30">
              <div className="d-flex align-items-center gap-25">
                <label htmlFor="" className="text-nowrap">Statement Generation</label>
                <div className="d-flex align-items-center gap-2">
                  <input type="text"
                    name="StatementCycleDays"
                    className="form-control"
                    id="StatementCycleDays"
                    autoComplete="off"
                    value={mainProvidereModal.StatementCycleDays}
                    onChange={handleProviderChange}
                    onKeyPress={(event) => handleNumericCheck(event)} />
                  <span>Days</span>
                </div>
              </div>
              <div className="d-flex align-items-center gap-25">
                <label htmlFor="" className="text-nowrap">Minimum Account Balance</label>
                <div className="d-flex align-items-center gap-2">
                  <input type="text"
                    className="form-control"
                    name="MinimumAccountBalance"
                    id="MinimumAccountBalance"
                    autoComplete="off"
                    value={mainProvidereModal.MinimumAccountBalance}
                    onChange={handleProviderChange}
                    onKeyPress={(event) => handleNumericCheck(event)}
                  />
                  <span className="text-nowrap">(in U.S.Dollars)</span>
                </div>
              </div>
            </div>
          </div>

          <div className="hk-statement__body d-flex flex-column">
            <div className="hk-statement__body__head d-flex align-items-center gap-6">
              <i class="icon-REALTIME fs-13 clr-dark"></i>
              <p className='heading fs-13 lh-1'>Dunning Messages</p>
            </div>
            <div className="hk-statement__body__content">
              <div className="w-75">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">Current To 30</label>
                  <input type="text"
                    className="form-control"
                    name="0to30DayDunningMessage"
                    id="0to30DayDunningMessage"
                    autoComplete="off"
                    value={mainProvidereModal["0to30DayDunningMessage"]}
                    onChange={handleProviderChange} />
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">31 To 60</label>
                  <input type="text"
                    className="form-control"
                    name="31to60DayDunningMessage"
                    id="31to60DayDunningMessage"
                    autoComplete="off"
                    value={mainProvidereModal["31to60DayDunningMessage"]}
                    onChange={handleProviderChange} />
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">61 To 90</label>
                  <input type="text"
                    className="form-control"
                    name="61to90DayDunningMessage"
                    id="61to90DayDunningMessage"
                    autoComplete="off"
                    value={mainProvidereModal["61to90DayDunningMessage"]}
                    onChange={handleProviderChange} />
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">Over 90</label>
                  <input type="text"
                    className="form-control"
                    name="Over90DayDunningMessage"
                    id="Over90DayDunningMessage"
                    autoComplete="off"
                    value={mainProvidereModal.Over90DayDunningMessage}
                    onChange={handleProviderChange} />
                </div>
              </div>
            </div>
          </div>

          <div className="hk-statement__body d-flex flex-column">
            <div className="hk-statement__body__head d-flex align-items-center gap-6">
              <i class="icon-Collection  fs-13 clr-dark"></i>
              <p className='heading fs-13 lh-1'>Move to Collection Management</p>
            </div>
            <div className="hk-statement__body__content">
              <div className="w-50 hk-statement__body__content__tinybox">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">
                    a) No. of days after sending the First Patient Statement
                  </label>
                  <input
                    className="form-control w-146px"
                    type="text"
                    name="NumberOfDaysAfterFirstStatementSend"
                    id="NumberOfDaysAfterFirstStatementSend"
                    autoComplete="off"
                    value={mainProvidereModal.NumberOfDaysAfterFirstStatementSend}
                    onChange={handleProviderChange}
                    onKeyPress={(event) => handleNumericCheck(event)} />
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="">b) No. of Patient Statements sent</label>
                  <input
                    type="text"
                    className="form-control w-146px"
                    name="NumberOfStatementSent"
                    id="NumberOfStatementSent"
                    autoComplete="off"
                    value={mainProvidereModal.NumberOfStatementSent}
                    onChange={handleProviderChange}
                    onKeyPress={(event) => handleNumericCheck(event)} />
                </div>
              </div>
            </div>
          </div>

          <div className="hk-statement__body d-flex flex-column">
            <div className="hk-statement__body__head d-flex align-items-center gap-6">
              <i class="icon-printing fs-13 clr-dark"></i>
              <p className='heading fs-13 lh-1'>Printing Options</p>
            </div>
            <div className="hk-statement__body__content">
              <div className="w-75 custom_check_box hk-statement__body__content__checkboxes">
                <div className="d-flex align-items-center gap-6">
                  <input type="checkbox"
                    id="DisplayAppointmentFicility"
                    name="DisplayAppointmentFicility"
                    autoComplete="off"
                    className="form-check-input"
                    checked={mainProvidereModal.DisplayAppointmentFicility}
                    onChange={(e) => handleProviderChange(e)} />
                  <label htmlFor="1">Display Appointment Facility</label>
                </div>
                <div className="d-flex align-items-center gap-6">
                  <input type="checkbox"
                    id="DisplayCPTDescription"
                    name="DisplayCPTDescription"
                    className="form-check-input"
                    autoComplete="off"
                    checked={mainProvidereModal.DisplayCPTDescription}
                    onChange={(e) => handleProviderChange(e)} />
                  <label htmlFor="2">Display CPT/HCPCS Description</label>
                </div>
                <div className="d-flex align-items-center gap-6">
                  <input type="checkbox"
                    id="DisplayPayments"
                    name="DisplayPayments"
                    autoComplete="off"
                    className="form-check-input"
                    checked={mainProvidereModal.DisplayPayments}
                    onChange={(e) => handleProviderChange(e)} />
                  <label htmlFor="3">Display Payments</label>
                </div>
                <div className="d-flex align-items-center gap-6">
                  <input type="checkbox"
                    id="DisplayCPTCode"
                    name="DisplayCPTCode"
                    autoComplete="off"
                    className="form-check-input"
                    checked={mainProvidereModal.DisplayCPTCode}
                    onChange={(e) => handleProviderChange(e)} />
                  <label htmlFor="4">Display CPT/HCPCS Code</label>
                </div>
                <div className="d-flex align-items-center gap-6">
                  <input type="checkbox"
                    id="DisplayClaimAdjustment"
                    name="DisplayClaimAdjustment"
                    autoComplete="off"
                    className="form-check-input"
                    checked={mainProvidereModal.DisplayClaimAdjustment}
                    onChange={(e) => handleProviderChange(e)} />
                  <label htmlFor="5">Display Claim Adjustment</label>
                </div>
              </div>
            </div>
          </div>

          <div className="hk-statement__body d-flex flex-column">
            <div className="hk-statement__body__head d-flex align-items-center gap-6">
              <i class="icon-mailing fs-10 clr-dark"></i>
              <p className='heading fs-13 lh-1'>Payment Mailing Address</p>
            </div>
            <div className="hk-statement__body__content">
              <div className="w-50 d-flex flex-column gap-2">
                <div className="input">
                  <label htmlFor="">Name</label>
                  <input type="text"
                    className="form-control"
                    name="Name"
                    id="Name"
                    autoComplete="off"
                    value={mainProvidereModal.Name}
                    onChange={handleProviderChange}
                  />
                </div>
                <div className="input">
                  <label htmlFor="">Address</label>
                  <textarea type="text"
                    rows={1}
                    className='form-control'
                    name="Address"
                    id="Address"
                    value={mainProvidereModal.Address}
                    onChange={handleProviderChange}
                  />
                </div>

                <div className="d-flex gap-3 w-100">
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className="input">
                      <label>City</label>
                      <input
                        type="text"
                        className="form-control"
                        name="City"
                        autoComplete="off"
                        value={mainProvidereModal.City}
                        onChange={handleProviderChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className='input'>
                      <label htmlFor="">State</label>
                      <SuperSearchList
                        type="client"
                        id='State'
                        name='State'
                        searchValue={mainProvidereModal.State}
                        data={States}
                        onChange={handleLocationChangeDD}
                        getSelectedData={handleSelectedData}
                        is={is}
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        ScrollOutside={true}
                      // filterWith="startsWith"
                      // tableHeight="200px"
                      // tableWidth="100%"
                      />
                      {/* {LocationValidationModal.StateVal} */}
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className="input">
                      <label>Zip Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="ZIPCode"
                        autoComplete="off"
                        maxLength={9}
                        value={mainProvidereModal.ZIPCode}
                        onChange={handleProviderChange}
                        onKeyPress={(event) => handleNumericCheck(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-3 w-100">
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className="input">
                      <label>Phone #</label>
                      <input
                        type="text"
                        className="form-control"
                        name="PhoneNo"
                        autoComplete="off"
                        value={mainProvidereModal.PhoneNo}
                        onChange={handleProviderChange}
                        max={11}

                      />
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className="input">
                      <label>Email</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Email"
                        autoComplete="off"
                        value={mainProvidereModal.Email}
                        onChange={handleProviderChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-75 custom_check_box hk-statement__body__content__checkboxes">
                  <div className="d-flex align-items-center gap-6">
                    <input type="checkbox"
                      id="IncludeLogo"
                      name="IncludeLogo"
                      autoComplete="off"
                      className="form-check-input"
                      checked={mainProvidereModal.IncludeLogo}
                      onChange={(e) => handleProviderChange(e)} />
                    <label htmlFor="4">Include Logo</label>
                  </div>
                  <div className="d-flex align-items-center gap-6">
                    <input type="checkbox"
                      id="IncludeFooter"
                      name="IncludeFooter"
                      autoComplete="off"
                      className="form-check-input"
                      checked={mainProvidereModal.IncludeFooter}
                      onChange={(e) => handleProviderChange(e)} />
                    <label htmlFor="4">Include Footer</label>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      {isLoading ? <Loader /> : null}
      {AddNewStatementModalBody()}
      <div className='tabs-action-bottom'>
        <div className='btns-group text-end px-3 br-bottom-1 br-top-1 br-clr d-flex align-items-center justify-content-end h-100'>
          <button className='btn btn-gray'>Cancel</button>
          <button className={IsEditAllowed ? 'btn btn-orange' : 'btn btn-orange disabled'} onClick={handleSaveProvider}>Save</button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Statement;
